import React from "react";
import Select, { components } from "react-select";

const CustomSelect = ({ options, isLoading, onChange, ...props }) => {
  const LoadingIndicator = () => (
    <div align="center" colSpan={8}>
      <div className="loader-wrapper">
        <div className="spinner-border text-light" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  );

  const LoadingOption = (props) => (
    <components.Option {...props}>
      <LoadingIndicator />
    </components.Option>
  );

  return (
    <Select
      {...props}
      options={
        isLoading ? [{ label: "Loading...", value: "loading" }] : options
      }
      components={{ Option: isLoading ? LoadingOption : components.Option }}
      onChange={(option) => {
        onChange(option ? option : null);
      }}

      styles={{
        ...props.styles,
        option: (styles, { isDisabled, isFocused, isSelected }) => ({
          ...styles,
          cursor: isDisabled ? "not-allowed" : "pointer",
          marginTop: "0px",
          marginBottom: "0px",
          color: isSelected ? "#fff" : "#1e2022",
          ...props.styles?.option?.(styles, { isDisabled, isFocused, isSelected }),
        }),
        control: (styles) => ({
          ...styles,
          backgroundColor: "#F7F5F5",
          borderRadius: "10px",
          color: "#1e2022",
          ...props.styles?.control?.(styles),
        }),
        singleValue: (styles) => ({
          ...styles,
          color: "#1e2022",
        }),
        placeholder: (styles) => ({
          ...styles,
          color: "#808080",
        }),
        menu: (styles) => ({
          ...styles,
          backgroundColor: "#F7F5F5",
          borderRadius: "10px",
          overflow: "hidden",
          ...props.styles?.menu?.(styles),
        }),
      }}
    />
  );
};

export default CustomSelect;
